/*
 * @Descripttion: 
 * @version: 
 * @Author: sueRimn
 * @Date: 2019-12-18 17:07:01
 * @LastEditors: mrh
 * @LastEditTime: 2021-01-12 15:29:23
 */
import axios from 'axios'

export function getScoreList(params) {
    return axios.post('teacher/1_0/getScoreList', params).then(res => res.data);
}
export function complainList(params) {
    return axios.post('teacher/1_0/order/complaint/list', params).then(res => res.data);
}
// 扣款详情（冬冬）
export function getDeductions(params) {
    return axios.post('teacher/1_0/withdrawal/ordersComplaintDetails', params).then(res => res.data);
}

//收入明细列表（冬冬） 
export function incomeList(params) {
    return axios.post('teacher/1_0/income/list', params).then(res => res.data);
}
//正常订单收入详情（冬冬） 
export function normalOrderDetails(params) {
    return axios.post('teacher/1_0/withdrawal/normalOrderDetails', params).then(res => res.data);
}
//提现纪录（冬冬） 
export function withdrawalRecord(params) {
    return axios.post('teacher/1_0/withdrawal/record', params).then(res => res.data);
}
//提现详情（冬冬） 
export function withdrawalDetail(params) {
    return axios.post('teacher/1_0/withdrawal/detail', params).then(res => res.data);
}
//提现详情（冬冬） 
export function uploadImageBase64(params) {
    return axios.post('comm/2_1/uploadImageBase64', params).then(res => res.data);
}

export function getPhone(params) {
    return axios.post('teacher/1_0/seller/info', params).then(res => res.data);
}

//2.5.0.1查询选菜师使用说明(郭伦)
export function findUseExplain(params) {
    return axios.post('/teacher/1_0/course', params).then(res => res.data);
}

//2.5.1采购金明细(冬冬)
export function purchaseList(params) {
    return axios.post('/teacher/1_0/purchase/list', params).then(res => res.data);
}

//2.5.1获取视频url(玉龙)
export function playUrl(params) {
    return axios.post('/comm/2_1/live/playUrl', params).then(res => res.data);
}
//2.5.1获取视频url(玉龙)
export function msgPayDetails(params) {
    return axios.post('/teacher/1_0/msg/msgPayDetails', params).then(res => res.data);
}

//2.5.1投诉回复(桂贤)
export function complaintProcess(params) {
    return axios.post('/teacher/1_0/order/complaint/process', params).then(res => res.data);
}

//2.5.1获取订单相关视频列表(玉龙)
export function getOrderVideos(params) {
    return axios.post('/comm/2_1/getOrderVideos', params).then(res => res.data);
}
//2.5.1获取举报详情(冬冬)
export function myReportDetails(params) {
    return axios.post('/teacher/1_0/msg/myReportDetails', params).then(res => res.data);
}
//采购金详情（冬冬） 
export function orderDetail(params) {
    return axios.post('/teacher/1_0/income/orderDetail', params).then(res => res.data);
}
// export function infoTwo(params) {
//     return axios.post('/store/InfoTwo', params, { headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' } }).then(res => res.data);
// }
//预收详情（冬冬）
export function getCfpExpectOrder(params) {
    return axios.post('/teacher/1_0/wallet/getCfpExpectOrders', params).then(res => res.data);
}

//260获取启动页图片（郭伦）
export function getStartPageImage(data) {
    return axios.post('/comm/2_1/getStartPageImage', data).then(res => res.data);
}

// 2.8.1卖家获取 获取文档协议（郭伦）
export function getActivityRuleContent(params) {
  return axios.post("/seller/2_1/getActivityRuleContent", params).then((res) => res.data);
}
